<!--
  @Description: 
  @Author: wang.y 
  @Date: 2024-07-26 
-->
<template>
  <div>
    <van-popup v-model="modelIndex" position="bottom" round @close="resetForms">
      <div class="login-view">
        <div class="view-top">
          <div class="container-title">{{'欢迎使用VBEF观众登录系统' | dealLanguage('Welcome to the VBEF system')}}</div>
          <div class="container-desc">
            {{'您可以通过此系统报名参加展会开具发票' | dealLanguage('You can register for the exhibition and issue invoices through this system')}}<br />
            {{'非常感谢您的参与' | dealLanguage('Thank you very much for your participation')}}
          </div>
          <img :src="static_img_url+'pic/vbef.png?v=' + $store.state.imgVersion" />
        </div>
        <div class="view-container">
          <Form ref="code-form" :model="codeForm" :rules="ruleValidate">
            <FormItem prop="mobile" :label="'手机号' | dealLanguage('Phone Number')">
              <div class="mobile-ipt">
                <span class="area-number" @click="showPicker = true">+{{loginNumber.mobileAreaCode}} &gt;</span>
                <Input type="text" v-model="codeForm.mobile" :placeholder="'请输入手机号' | dealLanguage('Please enter mobile phone number')" autocomplete="off"></Input>
              </div>
            </FormItem>
            <FormItem v-if="ncStatus">
              <div class="nc-cnt">
                <div id="nc"></div>
              </div>
            </FormItem>
            <FormItem prop="code" :label="'验证码' | dealLanguage('Phone Code')">
              <Input class="code-ipt" type="text" v-model="codeForm.code" maxlength="4" :placeholder="'请填写验证码' | dealLanguage('Please fill in the verification code')" autocomplete="off"></Input>
              <span class="code-btn" @click="haddleCode('code-form')" v-if="codeStatus == 0">{{'获取验证码' | dealLanguage('Get Code')}}</span>
              <span class="code-btn" @click="haddleCode('code-form')" v-if="codeStatus == 3">{{'重新获取' | dealLanguage('Reacquire')}}</span>
              <span class="code-btn disabled-btn" v-if="codeStatus == 1">{{'验证中' | dealLanguage('Loading')}}</span>
              <span class="code-btn disabled-btn" v-if="codeStatus == 2">{{`${wait}s后重新获取` | dealLanguage(`Reacquire (${wait})`)}}</span>
            </FormItem>
          </Form>

          <div class="checkbox-container">
            <div class="checkbox-tip-content" v-if="visible">
              <div class="checkbox-tip-arrow"></div>
              <div class="checkbox-tip-inner">{{'请阅读并勾选下方协议' | dealLanguage('Please read and check the agreement below')}}</div>
            </div>
            <Checkbox v-model="readSingle" size="small" @on-change="visible = false">
              <p class="checkbox-label">{{'我已阅读并同意' | dealLanguage('I have read and agreed to')}}<a :href="index2_path+'/mobile/privacyPolicy/2'" target="_blank">《动脉网用户协议》</a></p>
            </Checkbox>
          </div>
          <div class="checkbox-container">
            <div class="checkbox-tip-content" v-if="visible2">
              <div class="checkbox-tip-arrow"></div>
              <div class="checkbox-tip-inner">{{'请阅读并勾选下方协议' | dealLanguage('Please read and check the agreement below')}}</div>
            </div>
            <Checkbox v-model="readSingle2" size="small" @on-change="visible2 = false">
              <p class="checkbox-label">{{'我已阅读并同意' | dealLanguage('I have read and agreed to')}}<a :href="index2_path+'/mobile/privacyPolicy/1'" target="_blank">《隐私政策》</a></p>
            </Checkbox>
          </div>
          <p class="tip">{{'未注册的手机号将自动创建动脉网账号' | dealLanguage('Unregistered mobile phone numbers will automatically create an VBEF account')}}</p>
          <van-button type="primary" block @click="handleSubmit">{{'登录' | dealLanguage('Log in')}}</van-button>
        </div>
      </div>
    </van-popup>
    <van-popup v-model="showPicker" position="bottom">
      <van-picker :default-index="defaultIndex" show-toolbar :columns="appMobileAreaCodeDtos" @confirm="onConfirm" @cancel="showPicker = false" value-key="name">
        <template #option="item">
          <div>+{{item.mobileAreaCode}} ({{item.countryName | dealLanguage(item.countryEnName)}})</div>
        </template>
      </van-picker>
    </van-popup>
  </div>
</template>
<script>
import { loginCommon } from '@/assets/js/login'
import {
  editXuserChannel
} from '@/service/vbef'
import { mapState } from 'vuex'
export default {
  mixins: [loginCommon],
  inject: ['reload', 'checkIfThereAreSendTickets'],
  components: {},
  created() {
    // this.updateRuleValidate()
  },
  mounted() {
    this.initAWSC('code-form')
  },
  computed: {
    ...mapState({
      language: (state) => state.language,
    }),
  },
  data() {
    return {
      modelIndex: false,
      codeForm: {
        mobile: '',
        code: '',
      },
      showPicker: false,
      loginNumber: {
        id: 1,
        mobileAreaCode: '86',
        countryName: '中国',
        countryEnName: 'China'
      }
    }
  },
  methods: {
    onConfirm(item) {
      this.loginNumber = { ...item }
      this.showPicker = false
      // this.updateRuleValidate()
    },
    loginSuccess(data) {
      this.$notify({ type: 'success', message: this.language == 'zh' ? '登录成功' : 'Login successful' })

      this.$store.commit('updateUserKey', data.userKey)
      this.$store.commit('updateUser', data.xuser)
      this.$store.commit('setUUserId', data.xuser.id)

      this.modelIndex = false
      this.reload()
      this.checkIfThereAreSendTickets()
      const localsharechannel = localStorage.getItem('sharechannel') || 0
      console.log('localsharechannel', localsharechannel)
      if(localsharechannel) {
        this.editXuserChannel(localsharechannel)
      }
      if(this.successCb) this.successCb()
    },
    async editXuserChannel(localsharechannel) {
      let res = await editXuserChannel({
        actId: this.$store.state.activityId,
        channelId: localsharechannel,
      })
    },
    resetForms() {
      this.successCb = ''
      this.$refs['code-form'].resetFields()
      this.loginNumber = {
        ...{
          id: 1,
          mobileAreaCode: '86',
          countryName: '中国',
          countryEnName: 'China'
        },
      }
      this.visible = false
      this.visible2 = false
      this.codeImg = ''
      this.codeTime = 0
      this.codeOut = 0
      this.readSingle = false
      this.readSingle2 = false
      this.codeStatus = 0
      this.wait = 60
      clearInterval(this.waitInterval)
    },
  },
}
</script>
<style lang='stylus' scoped>
@import '~styles/login-m.styl'
</style>